import { runInAction } from 'mobx';
import { useLocalObservable } from 'mobx-react';
import { useMemo } from 'react';
export const useBoolean = (defaultValue = false) => {
    const store = useLocalObservable(() => ({
        valueInternal: defaultValue,
        setTrue: () => {
            store.toggle(true);
        },
        setFalse: () => {
            store.toggle(false);
        },
        toggle: (value) => {
            runInAction(() => {
                store.valueInternal = value !== null && value !== void 0 ? value : !store.valueInternal;
            });
        },
        get value() {
            return this.valueInternal;
        },
    }));
    const actions = useMemo(() => {
        const { setTrue, setFalse, toggle } = store;
        return { setTrue, setFalse, toggle };
    }, [store]);
    return [store.value, actions];
};
//# sourceMappingURL=use-boolean.js.map